export default __webpack_public_path__ + "static/media/validation.1e817c7b.svg";